import { APIs } from "./APIs";
import { getPath } from "../utils/getPath";

import type { AxiosInstance } from "axios";

import API = APIs.notificationsReadList;

export const getNotifications = (
  instance: AxiosInstance,
  pathParams: API.PathParam,
  query: API.Query,
  headers: Record<string, string>,
) => {
  return instance[API.method]<API.ResponseData>(getPath(API.path, pathParams), {
    params: query,
    headers,
  });
};
